import React from "react";
import PopupInput from "./PopupInput";
import {fieldErrorValue} from "../../../../../utils/errorUtils";
import useEnterKeyDown from "../../../../../hooks/useEnterKeyDown";

export default function PopupRestorePasswordForm({onTextTyping, sendRestorePasswordLink, values, fieldErrors}) {

    useEnterKeyDown(sendRestorePasswordLink);

    return (
        <form id="fpass-form" style={{display: "block"}}>
            <PopupInput type="email" name="email" placeholder="E-mail" onTextTyping={onTextTyping} value={values["email"]}
                        errorMsg={fieldErrorValue(fieldErrors, "email")}/>
            <a href="#" className="login-btn" id="getpass-btn" onClick={sendRestorePasswordLink}>Восстановить пароль</a>
        </form>
    )
}